const testimonials = [
  {
    id: 1,
    name: "Carlos Silva",
    role: "CTO na TechSolutions",
    content: "Trabalhar com esse desenvolvedor foi uma experiência transformadora para nossa equipe. Sua capacidade de resolver problemas complexos com soluções elegantes é impressionante. Entregou nosso projeto antes do prazo com qualidade excepcional.",
    avatar: "/avatar1.jpg",
    rating: 5
  },
  {
    id: 2,
    name: "Micael Lopes",
    role: "Analista de Dados",
    content: "O dashboard que Wescley criou revolucionou nossa análise de dados, reduzindo processos manais de 3 dias para relatórios em tempo real. Seu domínio de Python e Power BI transformou dados brutos em insights acionáveis, elevando nossa eficiência em 40%. Profissional raro que alia técnica excelente a comunicação clara. Recomendo!",
    avatar: "/avatar2.jpg",
    rating: 5
  },
  {
    id: 3,
    name: "Marcos Santos",
    role: "Aluno",
    content: "Isso sim é ensinar, não é aquela enrolação do (oculto) e do (oculto). PQP o conteúdo desses caras. Valeu Wescley Porto. Está de Parabéns.",
    avatar: "/avatar3.jpg",
    rating: 5
  },
  {
    id: 4,
    name: "João Cesar",
    role: "CEO VDC Informática",
    content: "Poxa amigo, a aula tava tão boa mas procurei a continuidade do conteúdo e não encontrei, uma pena.",
    avatar: "/avatar4.jpg",
    rating: 5
  }
];

export default testimonials;